<template>
  <!--菜单-->
  <div class="menu-container">
    <template v-for="item in menuList">
      <el-submenu
        :index="item.name"
        v-if="item.children && item.children.length > 0 && (item.is_admin && is_admin==1 || item.is_admin == undefined || !item.is_admin)"
        :key="item.name"
      >
        <template slot="title" v-if="item.is_admin && is_admin==1 || item.is_admin == undefined || !item.is_admin"> 
          <i
            class='iconfont'
            :class='item.meta.icon'
						:style="{background: `url(require('../../public/images/index/${item.meta.icon}.png')) no-repeat center/cover`}"
          ></i>
          <span>{{ item.meta.name }}</span>
        </template>
        <el-menu-item-group>
          <my-nav :menuList="item.children" v-if="item.is_admin && is_admin==1 || item.is_admin == undefined || !item.is_admin"></my-nav>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item
        :key="item.name"
        :index="item.name"
        @click="gotoRoute(item)"
        v-else-if="item.is_admin && is_admin==1 || item.is_admin == undefined || !item.is_admin"
      >
        <span slot="title">{{ item.meta.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script> 
export default {
  name: "my-nav",
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
	computed: {
      is_admin() {
     
        let localMes = this.$cache.get("searchOriginLoginMes");
        if (localMes) {
          let localMesObj = JSON.parse(localMes);

          if (localMesObj.user_info.jobs) {
            return localMesObj.user_info.jobs[0].is_admin;
          } else {
            this.$cache.remove("searchOriginLoginMes", "");
          }
        }
        return "请退出重新登录";
     
    },

		editableTabs:{
			get() {
				return this.$store.state.editableTabs;
			},
			set(val){
				this.$store.state.editableTabs = val;
			}
		},
  },
  methods: {
    gotoRoute(value) {
			let name = value.name;
      this.$router.push({ name });
    },
  },
};
</script>

<style lang='scss'>
.menu-container {
  .svg-icon {
    margin-right: 10px;
  }
}
.iconfont {
	display: inline-block;
	width: 15px;
	height: 15px;
	margin-right: 10px;
}
</style>
